namespace Gamification.Gamification {
    export interface ProdottiRisorseRow {
        IdProdottoRisorsa?: number;
        UserId?: number;
        TenantId?: number;
        IdProdotto?: number;
        IdRisorsa?: number;
        IdProdottoUserId?: number;
        IdProdottoTenantId?: number;
        IdProdottoIdTipologiaProdotti?: number;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
        IdProdottoBozza?: number;
        IdProdottoIdentifierPunteggio?: string;
        IdProdottoPunteggioNome?: string;
        IdProdottoPunteggioValoreIniziale?: number;
        IdProdottoPunteggioNegativo?: number;
        IdProdottoIdentifierCrediti?: string;
        IdProdottoCreditiNome?: string;
        IdProdottoCreditiValoreIniziale?: number;
        IdProdottoIdentifierEsperienza?: string;
        IdProdottoEsperienzaNome?: string;
        IdProdottoEsperienzaValoreIniziale?: number;
        IdRisorsaUserId?: number;
        IdRisorsaTenantId?: number;
        IdRisorsaIdTipologiaRisorsa?: number;
        IdRisorsaIdEstensione?: number;
        IdRisorsaIdTipologiaCaricamento?: number;
        IdRisorsaNome?: string;
        IdRisorsaDescrizione?: string;
        IdRisorsaNomeFileAssetBundle?: string;
        IdRisorsaNomeFileAssetPathFile?: string;
        IdRisorsaVersioneAssetBundle?: number;
        IdRisorsaUrlAssetBundle?: string;
        IdRisorsaNomeFileCoverAssetBundle?: string;
        IdRisorsaPathFileCoverAssetBundle?: string;
        IdRisorsaUrlCoverAssetBundle?: string;
        IdRisorsaEscludi?: number;
    }

    export namespace ProdottiRisorseRow {
        export const idProperty = 'IdProdottoRisorsa';
        export const localTextPrefix = 'Gamification.ProdottiRisorse';
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            IdProdottoRisorsa = "IdProdottoRisorsa",
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdotto = "IdProdotto",
            IdRisorsa = "IdRisorsa",
            IdProdottoUserId = "IdProdottoUserId",
            IdProdottoTenantId = "IdProdottoTenantId",
            IdProdottoIdTipologiaProdotti = "IdProdottoIdTipologiaProdotti",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione",
            IdProdottoBozza = "IdProdottoBozza",
            IdProdottoIdentifierPunteggio = "IdProdottoIdentifierPunteggio",
            IdProdottoPunteggioNome = "IdProdottoPunteggioNome",
            IdProdottoPunteggioValoreIniziale = "IdProdottoPunteggioValoreIniziale",
            IdProdottoPunteggioNegativo = "IdProdottoPunteggioNegativo",
            IdProdottoIdentifierCrediti = "IdProdottoIdentifierCrediti",
            IdProdottoCreditiNome = "IdProdottoCreditiNome",
            IdProdottoCreditiValoreIniziale = "IdProdottoCreditiValoreIniziale",
            IdProdottoIdentifierEsperienza = "IdProdottoIdentifierEsperienza",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome",
            IdProdottoEsperienzaValoreIniziale = "IdProdottoEsperienzaValoreIniziale",
            IdRisorsaUserId = "IdRisorsaUserId",
            IdRisorsaTenantId = "IdRisorsaTenantId",
            IdRisorsaIdTipologiaRisorsa = "IdRisorsaIdTipologiaRisorsa",
            IdRisorsaIdEstensione = "IdRisorsaIdEstensione",
            IdRisorsaIdTipologiaCaricamento = "IdRisorsaIdTipologiaCaricamento",
            IdRisorsaNome = "IdRisorsaNome",
            IdRisorsaDescrizione = "IdRisorsaDescrizione",
            IdRisorsaNomeFileAssetBundle = "IdRisorsaNomeFileAssetBundle",
            IdRisorsaNomeFileAssetPathFile = "IdRisorsaNomeFileAssetPathFile",
            IdRisorsaVersioneAssetBundle = "IdRisorsaVersioneAssetBundle",
            IdRisorsaUrlAssetBundle = "IdRisorsaUrlAssetBundle",
            IdRisorsaNomeFileCoverAssetBundle = "IdRisorsaNomeFileCoverAssetBundle",
            IdRisorsaPathFileCoverAssetBundle = "IdRisorsaPathFileCoverAssetBundle",
            IdRisorsaUrlCoverAssetBundle = "IdRisorsaUrlCoverAssetBundle",
            IdRisorsaEscludi = "IdRisorsaEscludi"
        }
    }
}
